<div class="relative w-full" #inputContainer>
   
    <!-- MAIN INPUT FIELD -->
    <input
        [type]="type"
        [disabled]="disabled"
        [placeholder]="placeholder"
        [class]="cssClass"
        [value]="inputValue"
        (input)="onInputChange($event)"
        (keydown)="onKeyDown($event)"
        (focus)="onFocus()"
        #inputField
    >

    <!-- SEARCH ICON -->
    <!-- Decorativa: pointer-events-none para que el tap enfoque el input -->
    <svg aria-hidden="true" class="pointer-events-none absolute end-2.5 top-1/2 -translate-y-1/2 size-3.5 rotate-90 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
    </svg>

    <!-- RESULTS CONTAINER -->
    @if(openResults){
       
        <div 
            class="absolute bottom-[36px] md:bottom-auto md:top-[110%] left-0 z-[1] w-full rounded-2xl bg-white shadow-md shadow-white/40 max-h-60 overflow-y-scroll no-scrollbar"
            tabindex="-1"
            role="listbox"
        >
            <ul>
            
                @for (option of filteredOptions; track option.value){
                    
                    <li 
                        (click)="selectOption(option)"
                        (keypress.enter)="selectOption(option)"
                        (mouseover)="hoverOption(option)"
                        (focus)="hoverOption(option)"
                        class="px-3 py-2 cursor-pointer text-black/70 hover:bg-black/10 font-semibold text-sm"
                        [class]="{'bg-black/10': highlightedIndex === filteredOptions.indexOf(option)}"
                        role="option"
                        tabindex="0"
                        aria-selected="false"
                    >
                        <span>
                            {{ option.label }}
                        </span>
                    </li>

                }

            </ul>
           
        </div>

    }

</div>
